export const translations = {
  'zh-TW': {
    title: 'Emoji Glint',
    subtitle: '領先的 AI 語意符號引擎：為文案畫龍點睛',
    description: 'Emoji Glint 提供基於 AI 語意分析的專業符號搜尋服務。支援最新 Unicode 規範，是創作者與 AI 提示詞工程師的首選效率工具。',
    searchPlaceholder: '輸入 Emoji、意圖或領域 (如：成長、質感、發財)...',
    searchResultTitle: '搜尋結果',
    recentTitle: '最近使用',
    skinToneTitle: '膚色選擇',
    copySuccess: '已複製 {char}！',
    copyCombo: '複製組合',
    copyComboSuccess: '已複製組合：{text}',
    clearTray: '清空暫存',
    supportUs: '贊助支持',
    hotLabel: '熱門',
    statusSearch: 'AI 語意精準匹配',
    statusAuthority: '專業符號資料庫',
    viewMore: '查看更多',
    categories: {
      all: '全部顯示',
      trends: '最新趨勢',
      social_media: '社群創作',
      copywriting_bullets: '文案排版',
      symbols_arrows: '引導箭頭',
      graphic_decoration: '裝飾符號',
      marketing_growth: '行銷增長',
      ecommerce_sales: '電商大促',
      tech_ai: '科技 AI',
      finance_crypto: '金融加密',
      architecture_urban: '建築城市',
      health_medical: '醫療健康',
      mahjong_culture: '雀神靈感',
      luxury_premium: '奢華質感',
      beauty_skincare: '美妝護膚',
      food: '美食飲品',
      travel_vacation: '旅遊度假',
      wellness_zen: '療癒禪意',
      zodiac_mystic: '星座神秘',
      faces: '情感表情',
      gestures: '人物動作',
      animals: '動物生物',
      nature: '自然天氣',
      objects: '生活物品',
      symbols: '符號標誌',
      flags: '國界世界'
    }
  },
  'en': {
    title: 'Emoji Glint',
    subtitle: 'Leading AI Semantic Symbol Engine',
    description: 'Emoji Glint provides professional AI-driven symbol search services. Supporting the latest Unicode standards, it is the premier tool for creators and prompt engineers.',
    searchPlaceholder: 'Search by emoji, intent, or field...',
    searchResultTitle: 'Search Results',
    recentTitle: 'Recents',
    skinToneTitle: 'Skin Tone',
    copySuccess: 'Copied {char}!',
    copyCombo: 'Copy Combo',
    copyComboSuccess: 'Combo Copied: {text}',
    clearTray: 'Clear Tray',
    supportUs: 'Sponsor Us',
    hotLabel: 'HOT',
    statusSearch: 'AI SEMANTIC MATCH',
    statusAuthority: 'SYMBOL DATABASE',
    viewMore: 'View More',
    categories: {
      all: 'Show All',
      trends: 'Trends',
      social_media: 'Social Content',
      copywriting_bullets: 'Copy Layout',
      symbols_arrows: 'Guide Arrows',
      graphic_decoration: 'Decorations',
      marketing_growth: 'Marketing',
      ecommerce_sales: 'E-commerce',
      tech_ai: 'Tech & AI',
      finance_crypto: 'FinTech',
      architecture_urban: 'Architecture',
      health_medical: 'Medical',
      mahjong_culture: 'Mahjong',
      luxury_premium: 'Premium',
      beauty_skincare: 'Beauty',
      food: 'Food & Drink',
      travel_vacation: 'Travel',
      wellness_zen: 'Zen',
      zodiac_mystic: 'Mystic',
      faces: 'Smiley Faces',
      gestures: 'Gestures',
      animals: 'Animals',
      nature: 'Nature',
      objects: 'Objects',
      symbols: 'Symbols',
      flags: 'Flags'
    }
  }
};